import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _2d33437d = () => interopDefault(import('../website/pages/404.vue' /* webpackChunkName: "pages/404" */))
const _1923efab = () => interopDefault(import('../website/pages/cart.vue' /* webpackChunkName: "pages/cart" */))
const _4454293e = () => interopDefault(import('../website/pages/catalog/index.vue' /* webpackChunkName: "pages/catalog/index" */))
const _223f0d51 = () => interopDefault(import('../website/pages/checkout.vue' /* webpackChunkName: "pages/checkout" */))
const _79cd5212 = () => interopDefault(import('../website/pages/index.html.vue' /* webpackChunkName: "pages/index.html" */))
const _2c1e615a = () => interopDefault(import('../website/pages/order.vue' /* webpackChunkName: "pages/order" */))
const _014ab51a = () => interopDefault(import('../website/pages/search.vue' /* webpackChunkName: "pages/search" */))
const _326abe4e = () => interopDefault(import('../website/pages/user/index.vue' /* webpackChunkName: "pages/user/index" */))
const _76d950d4 = () => interopDefault(import('../website/pages/catalog/details/index.vue' /* webpackChunkName: "pages/catalog/details/index" */))
const _cf2efae6 = () => interopDefault(import('../website/pages/user/loyalty.vue' /* webpackChunkName: "pages/user/loyalty" */))
const _127b2b24 = () => interopDefault(import('../website/pages/user/orders.vue' /* webpackChunkName: "pages/user/orders" */))
const _5d01af06 = () => interopDefault(import('../website/pages/user/restore-password/index.vue' /* webpackChunkName: "pages/user/restore-password/index" */))
const _7522af8c = () => interopDefault(import('../website/pages/catalog/details/_slug.vue' /* webpackChunkName: "pages/catalog/details/_slug" */))
const _6e086d14 = () => interopDefault(import('../website/pages/user/restore-password/_token.vue' /* webpackChunkName: "pages/user/restore-password/_token" */))
const _fe8a4aae = () => interopDefault(import('../website/pages/catalog/_product_group_slug.vue' /* webpackChunkName: "pages/catalog/_product_group_slug" */))
const _5db3e252 = () => interopDefault(import('../website/pages/index.vue' /* webpackChunkName: "pages/index" */))
const _9a78d338 = () => interopDefault(import('../website/pages/_.vue' /* webpackChunkName: "pages/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/404",
    component: _2d33437d,
    name: "404"
  }, {
    path: "/cart",
    component: _1923efab,
    name: "cart"
  }, {
    path: "/catalog",
    component: _4454293e,
    name: "catalog"
  }, {
    path: "/checkout",
    component: _223f0d51,
    name: "checkout"
  }, {
    path: "/index.html",
    component: _79cd5212,
    name: "index.html"
  }, {
    path: "/order",
    component: _2c1e615a,
    name: "order"
  }, {
    path: "/search",
    component: _014ab51a,
    name: "search"
  }, {
    path: "/user",
    component: _326abe4e,
    name: "user"
  }, {
    path: "/catalog/details",
    component: _76d950d4,
    name: "catalog-details"
  }, {
    path: "/user/loyalty",
    component: _cf2efae6,
    name: "user-loyalty"
  }, {
    path: "/user/orders",
    component: _127b2b24,
    name: "user-orders"
  }, {
    path: "/user/restore-password",
    component: _5d01af06,
    name: "user-restore-password"
  }, {
    path: "/catalog/details/:slug",
    component: _7522af8c,
    name: "catalog-details-slug"
  }, {
    path: "/user/restore-password/:token?",
    component: _6e086d14,
    name: "user-restore-password-token"
  }, {
    path: "/catalog/:product_group_slug",
    component: _fe8a4aae,
    name: "catalog-product_group_slug"
  }, {
    path: "/",
    component: _5db3e252,
    name: "index"
  }, {
    path: "/*",
    component: _9a78d338,
    name: "all"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config.app && config.app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
